import { ChangeEvent, useState } from 'react';
import { Field } from 'react-final-form';
import { required } from '../../../helpers';
import FormError from '../../Common/FormError';
import LocationWithAddress from '../../Common/LocationWithAddress';

const MortgageLoanForm = () => {
  const [isNewConstruction, setisNewConstruction] = useState(false);

  const handleNewConstructionChecked = (e: ChangeEvent<HTMLInputElement>) => {
    setisNewConstruction((prev) => !prev);
  };

  return (
    <>
      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Project Name</label>
        <Field name='project_name' type='text' validate={(v) => required(v, 'Project name')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Purchase Price</label>
        <Field name='purchase_price' type='number' validate={(v) => required(v, 'Purchase price')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Down Payment</label>
        <Field name='down_payment' type='number'>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Loan Amount</label>
          <Field name='loan_amount' type='number' validate={(v) => required(v, 'Loan amount')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Loan Tenure (in months)</label>
          <Field name='loan_tenure' type='number' validate={(v) => required(v, 'Loan tenure')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <LocationWithAddress label='Property Address' addressFormName='property_address' cityFormName='property_city' stateFormName='property_state' countryFormName='property_country' />

      <div className='row mt-5'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Property Title</label>
          <Field name='property_title' type='text' validate={(v) => required(v, 'Property title')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
        <div className='mb-5 col-lg-6'>
          <label className='form-label'>Property Type</label>
          <Field name='property_type' type='select' validate={(v) => required(v, 'Property type')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <select {...input} className='form-select form-select-lg form-select-solid'>
                    <option value=''></option>
                    <option value='Flat'>Flat</option>
                    <option value='Terrace'>Terrace</option>
                    <option value='Semi-Detached Duplex'>Semi-Detached Duplex</option>
                    <option value='Detached Duplex'>Detached Duplex</option>
                    <option value='Bungalow'>Bungalow</option>
                  </select>
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <div className='d-flex flex-stack mb-5 col-lg-12'>
        <div className='me-5'>
          <label className='fs-6 fw-bold form-label'>Is this a new construction?</label>
        </div>

        <label className='form-check form-switch form-check-custom form-check-solid'>
          <Field name='is_new_construction' type='checkbox'>
            {({ input, meta }) => (
              <>
                <input
                  className='form-check-input'
                  type='checkbox'
                  {...input}
                  onChange={(e) => {
                    input.onChange(e);
                    handleNewConstructionChecked(e);
                  }}
                />
                <FormError meta={meta} />
              </>
            )}
          </Field>
        </label>
      </div>

      {isNewConstruction ? (
        <>
          <div className='mb-5 col-lg-12'>
            <label className='form-label mb-3'>Developer Name</label>
            <Field name='developer_name' type='text' validate={(v) => required(v, 'Developer name')}>
              {({ input, meta }) => (
                <>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                    <FormError meta={meta} />
                  </div>
                </>
              )}
            </Field>
          </div>

          <LocationWithAddress label='Developer Address' addressFormName='developer_address' cityFormName='developer_city' stateFormName='developer_state' countryFormName='developer_country' />

          <label className='form-label mb-3 mt-5'>Contact Person's Detail</label>
          <div className='mb-5 col-lg-12'>
            <Field name='contact_name' type='text' validate={(v) => required(v, 'Contact name')}>
              {({ input, meta }) => (
                <>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                    <FormError meta={meta} />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className='row'>
            <div className='mb-5 col-lg-6'>
              <Field name='contact_phone' type='text' validate={(v) => required(v, "Developer's phone number")}>
                {({ input, meta }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' placeholder='Phone Number' {...input} className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-lg-6'>
              <Field name='contact_email' type='text'>
                {({ input, meta }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' placeholder='Email (Optional)' {...input} className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>
        </>
      ) : (
        <>
          <label className='form-label mb-3'>Contact Person's Details</label>
          <div className='mb-5 col-lg-12'>
            <Field name='contact_name' type='text' validate={(v) => required(v, 'Contact name')}>
              {({ input, meta }) => (
                <>
                  <div className='mb-3'>
                    <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                    <FormError meta={meta} />
                  </div>
                </>
              )}
            </Field>
          </div>

          <div className='row'>
            <div className='mb-5 col-lg-6'>
              <Field name='contact_phone' type='text' validate={(v) => required(v, "Contact's phone number")}>
                {({ input, meta }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' placeholder='Phone Number' {...input} className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </div>
                  </>
                )}
              </Field>
            </div>

            <div className='mb-5 col-lg-6'>
              <Field name='contact_email' type='text'>
                {({ input, meta }) => (
                  <>
                    <div className='mb-3'>
                      <input type='text' placeholder='Email (Optional)' {...input} className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </div>
                  </>
                )}
              </Field>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MortgageLoanForm;
